import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import "../../../static/styles/Ruler/leaflet-ruler.css";
import "../../../static/styles/Ruler/leaflet-ruler";

const LeafletRuler = () => {
  const map = useMap();
  const addRulerRef = useRef(false);

  useEffect(() => {
    if (!map) return;
    if(!addRulerRef.current){
      L.control.ruler().addTo(map);
      addRulerRef.current = true;
    }
  }, []);

  return null;
}
export default LeafletRuler;